//IMPORTING COLORS
import {
  WHITE,
  TEXT_COLOR,
  TITLE_COLOR_GK,
  ICON_COLOR_GK,
  FADE_BG_GK,
  FOOTER_BG_GK,
} from "../../utils/colors";

//IMPORTING FONT
import { TITLE_SIZE, SUB_TITLE_SIZE, TEXT_SIZE } from "../../utils/fonts";

//IMPORTING NUMBERS
import { WHATS_APP_LINK, WHATS_APP_TEXT } from "../../utils/phoneNumbers";

import { useEffect } from "react";
import DynamicTitle from "../../components/DynamicTitle";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BannerSection from "../../components/BannerSection";
import { HiOutlineChatAlt2 } from "react-icons/hi";
import FormSection from "../../components/FormSection";
import { FiPhoneCall } from "react-icons/fi";
import { TbClock24 } from "react-icons/tb";
import { FiPhone } from "react-icons/fi";
import { MdOutlineWhatsapp } from "react-icons/md";
import FooterBar from "../../components/FooterBar";
import ContatoBG from "../../assets/images/contato.jpg";
import "./Contato.css";

export default function Contato() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="contato-page">
      <DynamicTitle
        pageTitle="Grupo Krause - Contato"
        pageMeta="Grupo Krause"
        pageContent="Entre em contato conosco."
      />
      <BannerSection
        white={WHITE}
        fadeBG={FADE_BG_GK}
        iconTitle={
          <HiOutlineChatAlt2
            style={{ color: WHITE }}
            className="banner-section-icon"
          />
        }
        bannerTitle={"FALE CONOSCO"}
        bannerTitleSize={TITLE_SIZE}
        bannerSubTitle={"Tem alguma dúvida ou sugestão sobre nossos serviços?"}
        bannerSubTitleSize={SUB_TITLE_SIZE}
        bannerBG={ContatoBG}
        bannerBGmobile={ContatoBG}
      />
      <FormSection
        noLine="none"
        subTitleContent={
          <h3 style={{ color: TITLE_COLOR_GK, fontSize: SUB_TITLE_SIZE }}>
            Tem alguma dúvida ou sugestão sobre nossos serviços?
          </h3>
        }
        textContent={
          <p style={{ color: TEXT_COLOR, fontSize: TEXT_SIZE }}>
            Utilize o formulário, identificando o assunto de interesse, para que
            possamos conversar melhor.
          </p>
        }
        formSrc="https://cdn.bitrix24.com.br/b18068281/crm/form/loader_21.js"
        formData="inline/21/lu6czc"
      />
      <Container>
        <Row>
          <Col className="contato-first-col">
            <h2 style={{ color: TITLE_COLOR_GK, fontSize: TITLE_SIZE }}>
              <FiPhoneCall
                style={{ color: ICON_COLOR_GK }}
                className="contato-icon"
              />
              SE PREFERIR UTILIZE OS CANAIS DISPONÍVEIS
            </h2>
          </Col>
        </Row>
        <Row>
          <Col className="contato-col">
            <a
              href={`https://wa.me/${WHATS_APP_LINK}`}
              rel="noopener noreferrer"
            >
              <div className="contato-info-box">
                <MdOutlineWhatsapp
                  style={{ color: ICON_COLOR_GK }}
                  className="contato-info-icon"
                />
                <h2 style={{ color: TITLE_COLOR_GK, fontSize: TITLE_SIZE }}>
                  {WHATS_APP_TEXT}
                </h2>
              </div>
            </a>
          </Col>
          <Col className="contato-col">
            <a href="tel:05130369660" rel="noopener noreferrer">
              <div className="contato-info-box">
                <FiPhone
                  style={{ color: ICON_COLOR_GK }}
                  className="contato-info-icon"
                />
                <h2 style={{ color: TITLE_COLOR_GK, fontSize: TITLE_SIZE }}>
                  51 3036 9660
                </h2>
              </div>
            </a>
          </Col>
          <Col className="contato-col">
            <a href="tel:08000029600" rel="noopener noreferrer">
              <div className="contato-info-box">
                <TbClock24
                  style={{ color: ICON_COLOR_GK }}
                  className="contato-info-icon"
                />
                <h2 style={{ color: TITLE_COLOR_GK, fontSize: TITLE_SIZE }}>
                  0800 002 9600
                </h2>
              </div>
            </a>
          </Col>
        </Row>
      </Container>
      <FooterBar titleColor={TITLE_COLOR_GK} footerBarBG={FOOTER_BG_GK} />
    </div>
  );
}
